import { createAction, createAsyncAction } from "typesafe-actions";

import * as T from "./types";

export const fetchAnomalDataAsync = createAsyncAction(
  "FETCH_ANOMAL_DATA_REQUEST",
  "FETCH_ANOMAL_DATA_SUCCESS",
  "FETCH_ANOMAL_DATA_FAILURE"
)<void, Pick<T.Store, "anomalyDate" | "data">, void>();

export const fetchScreenerMetaAsync = createAsyncAction(
  "FETCH_SCREENER_META_REQUEST",
  "FETCH_SCREENER_META_SUCCESS",
  "FETCH_SCREENER_META_FAILURE"
)<string, T.ScreenerMeta, void>();

export const fetchScreenerFilterAsync = createAsyncAction(
  "FETCH_SCREENER_FILTER_REQUEST",
  "FETCH_SCREENER_FILTER_SUCCESS",
  "FETCH_SCREENER_FILTER_FAILURE"
)<T.ScreenerSetup, T.ScreenerResult[], void>();

export const fetchNavBarDataAsync = createAsyncAction(
  "FETCH_SCREENER_NARBAR_REQUEST",
  "FETCH_SCREENER_NARBAR_SUCCESS",
  "FETCH_SCREENER_NARBAR_FAILURE"
)<{ type: string; tickers: string[] }, { type: string; data: T.NavBarData[] }, void>();

export const fetchIndustryMetaAsync = createAsyncAction(
  "FETCH_SCREENER_INDUSTRY_SECTOR_META_REQUEST",
  "FETCH_SCREENER_INDUSTRY_SECTOR_META_SUCCESS",
  "FETCH_SCREENER_INDUSTRY_SECTOR_META_FAILURE"
)<string, Partial<T.ScreenerMeta>, void>();

export const updateScreenerSetup = createAction("UPDATE_SCREENER_SETUP")<Partial<T.ScreenerSetup>>();

export const updateFundamentalSetup = createAction("UPDATE_FUNDAMENTAL_SETUP")<{
  index: number;
  data: Partial<T.FundamentalOperation>;
}>();

export const loadTemplate = createAction("LOAD_SCREENER_TEMPLATE")<T.ScreenerSetup>();
